export default function (props: any) {
    return (
        <svg width="76" height="76" viewBox="0 0 76 76" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g fill="none" fillRule="evenodd">
                <path d="M0 0h76v76H0z" />
                <rect stroke="#979797" strokeWidth="2" x="7" y="19" width="62" height="38" rx="4" />
                <path stroke="#979797" strokeWidth="2" d="M6.821 34.096h62.313" />
                <path stroke="#979797" strokeWidth="2" strokeLinecap="round" d="M12.602 47.516h11.477" />
                <circle stroke="#979797" strokeWidth="2" cx="58.5" cy="47.5" r="3.5" />
            </g>
        </svg>
    );
}
